export const eventInitialValues = {
  title: '',
  start_date: '',
  end_date: '',
  start_time: '',
  end_time: '',
  overnight: false,
  description: '',
  observation: '',
  image: '',
  rules_for_children: '',
  own_transport: false,
  hasTickets: false,       
  requireCheckIn: false, 
  valor_ingresso_inteiro: 0,
  valor_ingresso_meia: 0,
  valor_ingresso_estudante: 0,
  valor_ingresso_crianca: 0,
  organizer_id: '',
  secondary_organizer_ids: [],
  dynamicFields: [],
  status: 'open', 
  registration_deadline: '', 
  // Métodos de pagamento
  payment_pix: true,
  payment_card: true,
  payment_boleto: true,
  // Taxas e juros (default: 0 = sem taxas)
  boleto_interest: 0,  // % juros ao mês
  boleto_fine: 0,      // % multa por atraso
  card_fee: 0,         // Taxa fixa do cartão (R$)
  card_fee_percent: 0, // Taxa percentual do cartão (%)
  // Máximo de parcelas
  max_installments_card: 10,    // Máximo de parcelas para cartão
  max_installments_boleto: 12,  // Máximo de parcelas para boleto
  // Exibição do organizador
  show_organizer_email: true,
  show_organizer_phone: true,
  // Personalização de tema
  theme_customization: undefined,
  // Personalização da seção de inscrição
  registration_title: '',
  registration_subtitle: '',
  gtm_container_id: '',
  group_registration_enabled: false,
};